module.exports = __webpack_public_path__ + "img/710-1bc98e.png";